"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["title"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Task = /*#__PURE__*/function (_React$PureComponent) {
  function Task() {
    (0, _classCallCheck2["default"])(this, Task);
    return _callSuper(this, Task, arguments);
  }
  (0, _inherits2["default"])(Task, _React$PureComponent);
  return (0, _createClass2["default"])(Task, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledTask, (0, _extends2["default"])({}, props, {
        title: title
      }), title);
    }
  }]);
}(_react["default"].PureComponent);
Task.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired
};
Task.defaultProps = {
  className: ''
};
var StyledTask = _styledComponents["default"].div.withConfig({
  displayName: "Task__StyledTask",
  componentId: "sc-1v3ir3c-0"
})(["background-color:#fff;border:1px solid #81bdff;border-radius:10px 0 0 10px;color:#007aff;font-size:12px;height:22px;line-height:20px;overflow:hidden;padding:0 4px 0 8px;position:relative;text-overflow:ellipsis;white-space:nowrap;"]);
var _default = exports["default"] = Task;